import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconDesktop from "@arco-design/web-react/icon/react-icon/IconDesktop";
import "@arco-design/web-react/es/Radio/style";
import _Radio from "@arco-design/web-react/es/Radio";
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import request from '@/utils/request';
import useLocale from '@/utils/useLocale';
import { removeAccessToken, removeRefreshToken } from '@/utils/token';
import locale from './locale';
import styles from './style/index.module.less';
export default function CreateCorpForm() {
  const formRef = useRef();
  const [createNew, setCreateNew] = useState(true);
  const RadioGroup = _Radio.Group;
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const t = useLocale(locale);
  function afterCreateCorpSuccess() {
    // 一定要先清除token
    removeAccessToken();
    removeRefreshToken();
    // 跳转首页
    window.location.href = '/login';
  }
  function createCorp(params) {
    setErrorMessage('');
    setLoading(true);
    request.post('/v1/user/create_corp', params).then(res => {
      const {
        code,
        message
      } = res.data;
      if (code === 200) {
        afterCreateCorpSuccess();
      } else {
        setErrorMessage(message || t['createCorp.form.createCorp.errMsg']);
      }
    }).finally(() => {
      setLoading(false);
    });
  }
  function onSubmitClick() {
    formRef.current.validate().then(values => {
      createCorp(values);
    }).catch(() => {
      // setErrorMessage(t['createCorp.form.createCorp.errMsg']);
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles['create-corp-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['create-corp-form-title']
  }, t['createCorp.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['create-corp-form-sub-title']
  }, t['createCorp.form.subtitle']), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RadioGroup, {
    direction: "vertical",
    defaultValue: createNew,
    onChange: setCreateNew
  }, /*#__PURE__*/React.createElement(_Radio, {
    value: true,
    className: styles['create-corp-form-radio']
  }, t['createCorp.form.create.new']), /*#__PURE__*/React.createElement(_Radio, {
    value: false,
    className: styles['create-corp-form-radio']
  }, t['createCorp.form.not.create']))), /*#__PURE__*/React.createElement("div", {
    className: styles['create-corp-form-error-msg']
  }, errorMessage), /*#__PURE__*/React.createElement(_Form, {
    className: styles['create-corp-form'],
    layout: "vertical",
    ref: formRef
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "corp_full_name",
    rules: [{
      required: true,
      message: t['createCorp.form.corp_full_name.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    allowClear: true,
    disabled: !createNew,
    prefix: /*#__PURE__*/React.createElement(_IconDesktop, null),
    placeholder: t['createCorp.form.corp_full_name.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(_Button, {
    disabled: !createNew,
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, t['createCorp.form.create']), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    long: true,
    className: styles['create-corp-form-login-btn'],
    onClick: () => history.push('/login')
  }, t['createCorp.form.login']))));
}